import { NAMESPACE, useLang } from '@/hooks/use-lang';
import { Button } from '@/shared/components';
import React, { useMemo, useState } from 'react';
import { useEventTracking } from '@/shared/tracking/use-tracking';

interface IProps {
  title: string;
  options: Array<{
    displayName: string;
    value: string;
  }>;
  className?: string;
  onViewMore?: () => void;
  limit?: number;
}

export const Card = (props: IProps) => {
  const { t } = useLang(NAMESPACE.pdp);
  const limit = props.limit ?? 5;
  const [showMore, setShowMore] = useState(false);
  const formatOptions = Array.isArray(props.options) ? props.options : [];
  const { trackEvent } = useEventTracking();
  const options = useMemo(() => {
    if (formatOptions.length <= limit) {
      return formatOptions;
    } else {
      if (showMore) {
        return formatOptions;
      } else {
        return formatOptions.slice(0, limit);
      }
    }
  }, [formatOptions, showMore]);

  const onViewMore = () => {
    if (props.onViewMore) {
      props.onViewMore();
    } else {
      const clicktype = props.title + ' ' + (showMore ? 'View Less' : 'View More');
      trackEvent({
        key: 'eventsData',
        action: 'PDPInteraction',
        payload: {
          event_name: 'PDPInteraction',
          PDP_interaction_type: clicktype,
        },
      });
      setShowMore(!showMore);
    }
  };
  return (
    <div
      className={`flex flex-col border border-gray-400 border-solid rounded-[3px] shadow-lg h-fit ${
        props.className ?? ''
      }`}
    >
      <p className="h-16 text-[26px] font-medium flex items-center pl-8">{props.title}</p>
      <div className="flex flex-col divide-y divide-x-0 divide-gray-400 divide-solid border-x-0 border-y border-gray-400 border-solid">
        {options.map((option, index) => (
          <div
            className="flex md:flex-col sm:flex-col divide-x divide-y-0 divide-gray-400 divide-solid text-sm"
            key={index}
          >
            <div className="capitalize flex-1 font-bold flex items-center pl-8 py-2">{option?.displayName ?? ''}</div>
            <div
              className="flex-1 font-normal items-center pl-8 py-2"
              dangerouslySetInnerHTML={{ __html: option?.value ?? '' }}
            />
          </div>
        ))}
      </div>
      <div className={`flex items-center justify-center ${formatOptions.length > limit ? '' : 'hidden'}`}>
        <Button type="link" onClick={onViewMore}>
          {showMore ? t('view.less') : t('view.more')}
        </Button>
      </div>
    </div>
  );
};
